import { render, staticRenderFns } from "./create-category.vue?vue&type=template&id=612cee4e&scoped=true"
import script from "./create-category.vue?vue&type=script&lang=js"
export * from "./create-category.vue?vue&type=script&lang=js"
import style0 from "./create-category.vue?vue&type=style&index=0&id=612cee4e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612cee4e",
  null
  
)

export default component.exports